import { Link } from "react-router-dom";
import { Play, Star } from "lucide-react";
import { mediaUrl } from "../lib/media";

export default function SeriesCard({ series }) {
    return (
        <Link
            to={`/series/${series.id}`}
            data-testid={`series-card-${series.id}`}
            className="group relative shrink-0 w-[260px] sm:w-[280px] snap-start"
        >
            <div className="relative aspect-[2/3] rounded-[18px] overflow-hidden bg-white/5 border border-white/5">
                <img
                    src={mediaUrl(series.poster)}
                    alt={series.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-90" />
                <div className="absolute top-3 left-3 flex gap-2">
                    {(series.tags || []).slice(0, 1).map((t) => (
                        <span key={t} className="text-[10px] font-bold uppercase tracking-wider bg-[#FFD400] text-black px-2 py-1 rounded">
                            {t}
                        </span>
                    ))}
                </div>
                <div className="absolute bottom-0 inset-x-0 p-4">
                    <h3 className="font-display text-xl font-bold text-white leading-tight">{series.title}</h3>
                    <div className="mt-1 flex items-center gap-2 text-xs text-white/70">
                        <span>{series.genre}</span>
                        <span className="w-1 h-1 rounded-full bg-white/40" />
                        <span className="flex items-center gap-1">
                            <Star className="w-3 h-3 fill-[#FFD400] text-[#FFD400]" />
                            {series.rating?.toFixed(1)}
                        </span>
                    </div>
                    <div className="mt-3 flex items-center justify-between">
                        <span className="text-xs text-white/60">{(series.episodes || []).length} Episodes</span>
                        <span className="inline-flex items-center gap-1 text-xs font-semibold text-black bg-[#FFD400] rounded-full px-3 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <Play className="w-3 h-3 fill-black" /> Watch
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
}
